import React from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Clock,
  ThumbsUp,
  Package,
  Utensils,
  Merge as Burger,
  Cookie,
  Wine,
  Globe,
  Cake,
  Leaf,
  Coffee,
  Croissant,
  Beef,
  UserCheck as CheeseIcon,
  Drumstick,
  Sandwich,
  Milk,
  GlassWater,
  Flower2,
  Apple,
  Wheat,
  Diamond,
  Pizza,
  FlameKindling,
} from "lucide-react";
const FilterSidebar = () => {
  const navigate = useNavigate();
  const subCategories = useSelector(
    (state) => state.subCategories?.groupSubCategories || []
  );
  const location = useLocation();
  const pathCategory = location.pathname.split("/")[1].toLowerCase();

  // Match categoryName with current route
  const matchedCategory = subCategories.find(
    (x) => x.categoryName.toLowerCase() === pathCategory
  );

  const handleClick = (subName) => {
    const currentPath = location.pathname.replace(/^\/+/, "");
    navigate(`/${currentPath}?filter=${encodeURIComponent(subName)}`);
  };

  return (
    <>
      <div className="filter-sidebar">
        <div className="sort-section">
          <h5 className="sidebar-heading">Sort by</h5>
          <ul className="list-unstyled">
            <li className="filter-item">
              <Clock size={18} />
              <span>Near me</span>
            </li>
            <li className="filter-item">
              <ThumbsUp size={18} />
              <span>Ratings</span>
            </li>
            <li className="filter-item">
              <Package size={18} />
              <span>Delivery Free</span>
            </li>
          </ul>
        </div>

        <div className="popular-filters-section">
          <h5 className="sidebar-heading">Popular filters</h5>
          <ul className="list-unstyled">
            {matchedCategory.subCategories.map(
              (sub, index) =>
                sub?.isPopular && (
                  <li
                    className="filter-item"
                    key={index}
                    onClick={() => handleClick(sub.name)}
                  >
                    {/* <Utensils size={18} /> */}
                    <div
                      style={{
                        width: 30,
                        height: 30,
                        borderRadius: "50%",
                        backgroundColor: "#efefef",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden", // ensures nothing spills outside
                      }}
                    >
                      <img
                        src={sub?.fileUrl}
                        alt="picture"
                        style={{
                          maxWidth: "70%",
                          maxHeight: "70%",
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                    <span>&nbsp;{sub.name}</span>
                  </li>
                )
            )}
            {/* <li className="filter-item">
              <Utensils size={18} />
              <span>American</span>
            </li>
            <li className="filter-item">
              <Burger size={18} />
              <span>Burgers</span>
            </li>
            <li className="filter-item">
              <Cookie size={18} />
              <span>Snacks</span>
            </li> */}
          </ul>
        </div>

        {matchedCategory?.subCategories?.length > 0 && (
          <div className="more-filters-section">
            <h5 className="sidebar-heading">More filters</h5>
            {/* <ul className="list-unstyled">
            <li className="filter-item">
              <Wine size={18} />
              <span>Alcohol</span>
            </li>
            <li className="filter-item">
              <Globe size={18} />
              <span>Arabic</span>
            </li>
            <li className="filter-item">
              <Utensils size={18} />
              <span>Asian</span>
            </li>
            <li className="filter-item">
              <Cake size={18} />
              <span>Bakery</span>
            </li>
            <li className="filter-item">
              <Leaf size={18} />
              <span>Bio</span>
            </li>
            <li className="filter-item">
              <Coffee size={18} />
              <span>Breakfast</span>
            </li>
            <li className="filter-item">
              <Croissant size={18} />
              <span>Brunch</span>
            </li>
            <li className="filter-item">
              <Beef size={18} />
              <span>Butcher's</span>
            </li>
            <li className="filter-item">
              <CheeseIcon size={18} />
              <span>Cheese</span>
            </li>
            <li className="filter-item">
              <Drumstick size={18} />
              <span>Chicken</span>
            </li>
            <li className="filter-item">
              <Sandwich size={18} />
              <span>Churros</span>
            </li>
            <li className="filter-item">
              <Milk size={18} />
              <span>Dairy</span>
            </li>
            <li className="filter-item">
              <GlassWater size={18} />
              <span>Drinks</span>
            </li>
            <li className="filter-item">
              <Flower2 size={18} />
              <span>Flowers</span>
            </li>
            <li className="filter-item">
              <Apple size={18} />
              <span>Fruit & Veg</span>
            </li>
            <li className="filter-item">
              <Wheat size={18} />
              <span>Gluten Free</span>
            </li>
            <li className="filter-item">
              <Diamond size={18} />
              <span>Gourmet</span>
            </li>
            <li className="filter-item">
              <Pizza size={18} />
              <span>Greek</span>
            </li>
            <li className="filter-item">
              <FlameKindling size={18} />
              <span>Grill</span>
            </li>
          </ul> */}
            <ul className="list-unstyled">
              {matchedCategory.subCategories.map((sub, index) => (
                <li
                  className="filter-item"
                  key={index}
                  onClick={() => handleClick(sub.name)}
                >
                  {/* <Utensils size={18} /> */}
                  <div
                    style={{
                      width: 30,
                      height: 30,
                      borderRadius: "50%",
                      backgroundColor: "#efefef",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      overflow: "hidden", // ensures nothing spills outside
                    }}
                  >
                    <img
                      src={sub?.fileUrl}
                      alt="picture"
                      style={{
                        maxWidth: "70%",
                        maxHeight: "70%",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <span>&nbsp;{sub.name}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
        {/* </div> */}
      </div>
    </>
  );
};

export default FilterSidebar;
